export default "__VITE_ASSET__FhASK$kl__"